import { useGeneratePassKeyAuthentication } from '@/api/iam/mutations/useGeneratePassKeyAuthentication';
import { usePassKeyLogin } from '@/api/iam/mutations/usePassKeyLogin';
import { AuthStep } from '@/enums/auth/authStep';
import {
  PublicKeyCredentialRequestOptionsJSON,
  startAuthentication,
} from '@simplewebauthn/browser';
import { Button } from '@starsoft/common/components';
import { AuthLoginRequestDto } from '@starsoft/common/dto';
import { useSearchParams } from '@starsoft/common/hooks';
import { getComputedColor } from '@starsoft/common/utils';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';
import styles from './styles.module.scss';

export default function PassKeyButton() {
  const { t } = useTranslation('common');
  const search = useSearchParams();
  const isKyc = search.get('step') === AuthStep.Kyc;
  const { watch } = useFormContext<AuthLoginRequestDto>();
  const { passKeyLogin, isPending: pendingPassKeyLogin } = usePassKeyLogin();
  const email = watch('email');

  const onSuccess = async (data: PublicKeyCredentialRequestOptionsJSON) => {
    try {
      const credential = await startAuthentication({
        optionsJSON: data,
      });
      passKeyLogin({
        email,
        payload: credential,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const { generatePassKeyAuthentication, isPending } =
    useGeneratePassKeyAuthentication({
      externalOnSuccess: onSuccess,
    });

  function handleClick() {
    generatePassKeyAuthentication({ email });
  }

  if (isKyc) {
    return null;
  }

  return (
    <div className={styles.container}>
      {/* <div className={styles.container__divider}>
        <div className={styles.container__divider__line} />
        <span className={styles.container__divider__text}>
          {t('make_login_easier')}
        </span>
        <div className={styles.container__divider__line} />
      </div> */}
      <Button
        onClick={handleClick}
        isTransparent
        style={{
          width: '100%',
          color: getComputedColor('--text-secondary-color'),
        }}
        isloading={pendingPassKeyLogin || isPending}
      >
        <i className="fa-solid fa-key" />
        {t('passkey_label')}
      </Button>
    </div>
  );
}
